<div class="modal-header">
    <h5 class="modal-title pull-left">{{greetInfo.agent}}</h5>
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
        <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="container">
        <div class="table-responsive">
            <table class="table table-hover table-striped table-bordered mb-2">
                <thead class="thead-light">
                    <tr>
                        <th scope="col">RES ID</th>
                        <th scope="col">Start Time</th>
                        <th scope="col">End Time</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{{greetInfo.resId}}</td>
                        <td>{{getFormatedDate(greetInfo.startTime)}}</td>
                        <td>{{getFormatedDate(greetInfo.endTime)}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="row">
            <div class="col-md-12 col-xl-12 col-sm-12">
                <div class="position-relative form-group">
                    <h6>Reason</h6>
                    <textarea class="form-control" id="exampleText" name="text" rows="6"
                        [(ngModel)]="reason"></textarea>
                </div>
            </div>
            <div class="col-md-8">
                <button class="btn btn-danger btn-sm" (click)="greetReject()">Reject Greet
                </button>
            </div>
        </div>
    </div>

</div>